import { axiosInstance } from '@/lib/axios';
import { TimesheetAdditionalConfigurationRaw } from './types';

type Props = {
  companyId: string
  payload: TimesheetAdditionalConfigurationRaw
}

export function updateTimesheetAdditionalSettings({ companyId, payload }: Props) {
  return axiosInstance.post<TimesheetAdditionalConfigurationRaw>(`/api/${companyId}/configuration/saveTimesheetAdditionalConfiguration`, {
    configuration: payload
  });
}
